import {Component} from '@angular/core';
import {DisplayStrings} from '../../constants/DisplayStrings';

@Component({
  selector: 'app-permission-denied',
  templateUrl: './permission-denied.component.html',
  styleUrls: [
    '../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class PermissionDeniedComponent {
  readonly DisplayStrings = DisplayStrings;
}
